import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaSmog, FaBolt, FaDoorClosed, FaHardHat, FaTruckMoving, FaClock } from 'react-icons/fa';
import AnimateOnScroll from './AnimateOnScroll';

const items = [
  { icon: <FaSmog size={18} />, key: 'item1' },
  { icon: <FaBolt size={18} />, key: 'item2' },
  { icon: <FaDoorClosed size={18} />, key: 'item3' },
  { icon: <FaHardHat size={18} />, key: 'item4' },
  { icon: <FaTruckMoving size={18} />, key: 'item5' },
  { icon: <FaClock size={18} />, key: 'item6' },
];

export default function SentinelWatch() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" id="sentinel-watch">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <AnimateOnScroll animation="fadeRight">
            <div>
              <p className="t-h1">{t('SentinelWatch.label')}</p>
              <h2 className="t-h2" style={{ maxWidth: '28rem' }}>{t('SentinelWatch.title')}</h2>
              <p
                className="font-semibold mb-3"
                style={{ color: '#010C66', fontFamily: '"Wix Madefor Display", sans-serif', fontSize: '1rem' }}
              >
                {t('SentinelWatch.tagline')}
              </p>
              <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.95rem', marginBottom: '1rem', maxWidth: '30rem' }}>
                {t('SentinelWatch.intro')}
              </p>
              <p style={{ color: '#9ca3af', lineHeight: 1.6, fontSize: '0.8rem', maxWidth: '30rem' }}>
                {t('SentinelWatch.disclaimer')}
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fadeLeft">
            <div className="grid grid-cols-2 gap-4">
              {items.map((item, i) => (
                <div
                  key={i}
                  className="p-5 rounded-2xl border transition-all duration-300 hover:shadow-md"
                  style={{ borderColor: '#e5e7eb' }}
                >
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center mb-3"
                    style={{ background: '#f0f2ff', color: '#010C66' }}
                  >
                    {item.icon}
                  </div>
                  <p style={{ color: '#374151', fontSize: '0.85rem', fontWeight: 500 }}>
                    {t(`SentinelWatch.${item.key}`)}
                  </p>
                </div>
              ))}
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>
  );
}
